<template>
    <div>
        <AppHeader/>
        <v-form class="ma-5">
            <v-container>
                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="12" lg="8">
                        <div class="video-container">
                            <iframe
                                    class="video"
                                    src="https://www.youtube.com/embed/kmIST8wM7wU"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                            ></iframe>
                        </div>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                        <div class="backgroundColor1">
                            <v-card-title>Zusätzliche Materialien</v-card-title>
                            <v-card-text>
                              <span>
<!--                                <a href="" target="_blank">Blog:</a> Digitale Kompetenzen von Mitarbeitern entwickeln-->
                              </span>
                                <br/>
                                <span>
                                <a href="./../static/thesenpapier_digitale_kompetenz_von_mitarbeitern_fördern.pdf" target="_blank">PDF</a> zur Übersicht und Übertragung in die Praxis
                            </span>
                            </v-card-text>
                        </div>
                    </v-col>
                </v-row>
                <v-row class="mt-5 backgroundColor1">
                    <v-col>
                        <v-card-title>Digitale Kompetenzen von Mitarbeitern fördern</v-card-title>
                        <v-card-text>
                            Der Unternehmenserfolg ist maßgeblich von den Mitarbeitern und Mitarbeiterinnen abhängig.
                            Umso wichtiger ist es, transparente Änderungsprozesse mit notwendigen Kompetenzerweiterungen
                            zu stärken.
                            Eine geschickte Kombination aus Motivation und Fähigkeiten führt letztlich zur Erreichung
                            von Unternehmenszielen. Bündeln Sie interne Stärken und bauen Sie diese aus.
                        </v-card-text>
                        <v-card-actions>
                            <router-link to="/" class="text-decoration-none">
                                <v-btn color="third" class="white--text mt-3">zur Übersicht</v-btn>
                            </router-link>
                        </v-card-actions>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>

<script>
    import AppHeader from "./AppHeader";

    export default {
        components: {
            AppHeader,
        },
        data() {
            return {};
        },
    };
</script>

<style scoped>
    .backgroundColor1 {
        background-color: #f7f7f7;
        height: 100%;
        padding: 1em;
    }

    .video-container {
        position: relative;
        padding-bottom: 56.25%;
        padding-top: 0;
        height: 0;
        overflow: hidden;

    }

    .video-container iframe,
    .video-container object,
    .video-container embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>